<script>

    import { toast } from 'bulma-toast'
    import { providerStore, providersStore, modalStore, adminStore } from '../stores'

    import { isPermission } from '../$methods/permissions.methods'

    import ProvidersService from '../$services/providers.service'
    import DateMethods from '../$methods/date.methods'
    import TranslateMethods from '../$methods/translate.methods'

    import ButtonDelete from '../$components/button.delete.svelte'
    import Button from '../$components/button.svelte'
    import InfoCard from '../$components/info.card.svelte'
    import InfoField from '../$components/info.field.svelte'

    let loading = false

    async function deleteProvider() {

        loading = true
        const resp = await ProvidersService.deleteProvider($providerStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        providersStore.remove($providerStore._id)
        toast({message: 'Proveedor borrado', type: 'is-success'})

        modalStore.close()
    }

</script>

<InfoCard subtitle="Proveedor">
    <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
        <InfoField label="Proveedor" icon="fas fa-truck" value={ $providerStore.name } bold />
        <InfoField label="Estatus" icon="fas fa-info-circle" value={ TranslateMethods.get($providerStore.status) } />
        <InfoField label="Fecha de creación" icon="far fa-calendar-alt" value={ DateMethods.dateTimeLarge($providerStore.created) } />
    </div>
</InfoCard>

<div class="items-end">
    <div class="buttons">
        {#if isPermission($adminStore, 'SettingsView.Provider.Create')}
            <Button on:click={() => modalStore.open('provider', 'update_modal', $providerStore)} icon="edit" text="Actualizar" { loading } />
        {/if}
        {#if isPermission($adminStore, 'SettingsView.Provider.Create')}
            <ButtonDelete on:confirm={deleteProvider} { loading } />
        {/if}
    </div>
</div>
